export default "__VITE_ASSET__RogWRGB___"